import type { TRuleWithTheme } from '@ackee/fela';

import { BackgroundMode } from '../../PixelatedBackgroundWrapper/constants';

interface Props {
    backgroundMode?: BackgroundMode;
}

export const container: TRuleWithTheme = () => ({
    display: 'grid',
    gridTemplateColumns: 'repeat(1, 1fr)',
    rowGap: '2.5rem',
    columnGap: '5.88rem',

    paddingBottom: '10rem',
    paddingRight: '4rem',

    desktopLarge: {
        gridTemplateColumns: 'repeat(2, 1fr)',
        paddingBottom: '14rem',
        paddingRight: '10rem',
    },
});

export const stat: TRuleWithTheme<Props> = ({ theme, backgroundMode }) => ({
    color: backgroundMode === BackgroundMode.Dark ? theme.colors.white : theme.colors.black,
    transition: 'color 0.3s',
});

export const statName: TRuleWithTheme = () => ({
    display: 'block',

    fontSize: '1rem',
    fontWeight: 500,
    lineHeight: '1.625rem',
});

export const statValue: TRuleWithTheme = () => ({
    display: 'block',

    fontSize: '3rem',
    fontWeight: 800,
    lineHeight: '3.625rem',
});
